module.exports = __webpack_public_path__ + "img/16_dicas_fundamentai_sCX81.854e5888.png";